// extracted by mini-css-extract-plugin
export default {"francheese__app":"App_francheese__app__3Pdwm","fadeIn":"App_fadeIn__tXW+i","fadeOut":"App_fadeOut__zWEBV"};